import * as React from 'react';

import initBem from 'js/lib/bem';

import { Typography2 } from '@coursera/cds-core';

import 'css!./__styles__/ReviewRubricHeader';

const bem = initBem('ReviewRubricHeader');

type Props = {
  children: JSX.Element;
};

const ReviewRubricHeader = ({ children }: Props) => {
  return (
    <div className={bem()}>
      <div className={bem('header')}>
        <Typography2 variant="bodyPrimary" component="div" className={bem('left-side')}>
          {children}
        </Typography2>
        {/* TODO: Render when feature gets implemented */}
        {/* <Typography variant="body1" component="span" className={bem('right-side')}>Rubric not clear? <Button size="zero" type="link" label={_t('Give Feedback')} onClick={() => {}} /></Typography> */}
      </div>
    </div>
  );
};

export default ReviewRubricHeader;
